// Globals
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputNumber } from 'antd';

// Components
import { Modal, ModalSize } from '@/components';
import { Button } from '@/ui';

interface RecordRefundModalProps {
  isOpen: boolean;
  isLoading: boolean;
  defaultAmount?: number;
  onClose: () => void;
  onSubmit: (payload: { amount: number }) => void;
}

const RecordRefundModal = ({ isOpen, isLoading, defaultAmount = 0, onClose, onSubmit }: RecordRefundModalProps) => {
  const { t } = useTranslation(['orders']);
  const [amount, setAmount] = useState<number>(defaultAmount);

  useEffect(() => {
    if (isOpen) {
      setAmount(defaultAmount);
    }
  }, [isOpen, defaultAmount]);

  const handleSubmit = () => {
    if (!amount || amount <= 0) {
      return;
    }

    onSubmit({ amount });
  };

  return (
    <Modal visible={isOpen} onCancel={onClose} size={ModalSize.LARGE}>
      <h3>{t('orders_record_refund')}</h3>
      <p>{t('orders_record_refund_amount')}</p>
      <InputNumber
        style={{ width: '100%', marginBottom: 16 }}
        min={0.01}
        step={0.01}
        value={amount}
        onChange={(value) => setAmount(Number(value) || 0)}
      />
      <Button type="primary" loading={isLoading} disabled={!amount || amount <= 0} onClick={handleSubmit}>
        {t('orders_record_refund')}
      </Button>
    </Modal>
  );
};

export default RecordRefundModal;
